import axios, { Method, ResponseType } from 'axios';
import config from '@/config';
import Auth from '@/shared/auth';
import { Incident, Program, Teen } from './types';

export async function request<T = {}> (method: Method = 'get', url: string, data = {}, responseType: ResponseType = 'json') {
  try {
    const user = await Auth.getUser();
    const result = await axios.request<T>({
      method,
      url: `${config.api}${url}`,
      data,
      responseType,
      headers: {
        'Content-Type': 'application/json',
        ...(user ? { Authorization: `Bearer ${user.access_token}` } : {})
      }
    });
    return result;
  } catch (e) {
    const error = e.response || {};
    const {
      status,
      statusText,
      headers,
      config: { url, data, method }
    } = error;
    console.log({
      status,
      statusText,
      headers,
      config: { url, data, method }
    });
  }
};

const baseController = 'SummerIncidentReport';
const api = {
  summerIncidentReportTeenLookup (query: string, program: number) {
    return request<Teen[]>('get', `${baseController}/lookup?searchterm=${query}&program=${program}`);
  },
  summerIncidentReportLookup (query: string, page: number, size: number, where: string) {
    return request<{
      Result: Incident[]; TotalCount: number;
    }>('get', `${baseController}?searchterm=${query}&page=${page}&pagesize=${size}&where=${where}`);
  },
  getSummerPrograms () {
    return request<Program[]>('get', `${baseController}/programs`);
  },
  getIncident (id: number | string) {
    return request<Incident>('get', `${baseController}/${id}`);
  },
  getSeasons () {
    return request<string[]>('get', `${baseController}/seasons`);
  },
  upsertIncident (method: Method, data: Incident) {
    return request<{ PrincipalID: number }>(method, baseController, data);
  },
  deleteIncident (id: number) {
    return request('delete', `${baseController}/${id}`);
  }
};

export default api;
